<template>
    <footer class="flex flex-col items-center gap-3 p-3 sm:flex-row justify-center">
        
        <div class="links flex gap-4">
            <a :href="$root.app.terms_of_use_url" target="_blank" class="text-black no-underline">Terms of Use</a>
            <a :href="$root.app.privacy_policy_url" target="_blank" class="text-black no-underline">Privacy Policy</a>
            <a :href="$root.app.contact_us_url" target="_blank" class="text-black no-underline">Need Help?</a>
        </div>
        <div class="rights">
            <p class="text-black">
                © {{ currentYear() }} {{ $root.app.company_name }}. All Rights Reserved
            </p>
        </div>
    </footer>
</template>

<script>

import Moment from 'moment';

export default {
    data() {
        return {
            
        }
    },
    methods: {
        currentYear() {
            return Moment().year();
        }
    }
}

</script>